module.exports = __webpack_public_path__ + "static/media/bg-lake-tablet.53f19982.jpg";